import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class CallingListService {
  clearNote$ = new BehaviorSubject<any>({});
}
